import { ScrollSpy, ScrollSpyItem } from '@toggle/design-system';
import React from 'react';

import styles from './Sidebar.module.scss';

export const Sidebar = ({
  containerRef,
  items,
}: {
  containerRef: React.RefObject<HTMLElement | null>;
  items: ScrollSpyItem[];
}) => {
  return (
    <div className={styles.sidebarContainer}>
      <ScrollSpy items={items} containerRef={containerRef} />
    </div>
  );
};
